/**
 * Mock data for timetable generation interface
 */

export interface GenerationSettings {
  profileId: string;
  maxGenerationTime: number;
  allowSoftRuleViolations: boolean;
  maxSoftRuleViolations: number;
  prioritizeTeacherWellbeing: boolean;
  prioritizeStudentWellbeing: boolean;
  prioritizeRoomEfficiency: boolean;
}

export interface GenerationProgress {
  status: 'idle' | 'preparing' | 'generating' | 'validating' | 'complete' | 'error';
  progress: number; // 0-100
  currentStep: string;
  message: string;
  startTime?: Date;
  endTime?: Date;
  timetableId?: string;
}

export const defaultGenerationSettings: GenerationSettings = {
  profileId: 'profile-2', // Balanced Optimization
  maxGenerationTime: 120,
  allowSoftRuleViolations: true,
  maxSoftRuleViolations: 10,
  prioritizeTeacherWellbeing: true,
  prioritizeStudentWellbeing: true,
  prioritizeRoomEfficiency: false,
};

export const mockGenerationProgress: GenerationProgress = {
  status: 'idle',
  progress: 0,
  currentStep: 'Ready to generate',
  message: 'Click Generate Timetable to begin',
};

// Simulation of generation steps
export const generationSteps = [
  { progress: 10, step: 'Validating Configuration', message: 'Checking school structure, teachers, and curriculum data...' },
  { progress: 20, step: 'Loading Rules', message: 'Loading hard rules, soft rules, and preferences...' },
  { progress: 30, step: 'Initializing Generator', message: 'Setting up generation algorithm with selected profile...' },
  { progress: 40, step: 'Assigning Core Subjects', message: 'Placing English, Maths, and Science lessons...' },
  { progress: 50, step: 'Assigning Elective Subjects', message: 'Scheduling optional subjects and activities...' },
  { progress: 60, step: 'Optimizing Teacher Schedules', message: 'Minimizing teacher gaps and split days...' },
  { progress: 70, step: 'Optimizing Room Allocation', message: 'Maximizing room utilization efficiency...' },
  { progress: 80, step: 'Applying Teacher Preferences', message: 'Accommodating approved teacher requests...' },
  { progress: 90, step: 'Validating Constraints', message: 'Checking all hard rules and soft rules...' },
  { progress: 95, step: 'Detecting Conflicts', message: 'Identifying any scheduling conflicts...' },
  { progress: 100, step: 'Generation Complete', message: 'Timetable generated successfully!' },
];

export const mockQuickStats = {
  totalLessons: 0,
  assignedLessons: 0,
  conflicts: 0,
  hardRuleViolations: 0,
  softRuleViolations: 0,
  estimatedTime: '2 minutes',
};
